export const VeckoFonts = {
  textFont: 'Roboto'
};